import {combineReducers} from 'redux';
import dashboard from './dash.reducer';

const hsseDash = combineReducers({
    dashboard,
});

export default hsseDash;
